module.exports = __webpack_public_path__ + "img/info.345eaa53.svg";